/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ComponentFieldKey } from '../model/component.model';
import { ViewComponentKey } from '../key/view-component.key';
import { ContentData, ContentModel } from './content.component-model';

export interface TableCellData extends ContentData {
  row: number;
  column: number;
  rowSpan?: number;
  columnSpan?: number;
  // format?: string;
  // alignment?: Alignment;
}

export class TableCellFieldKey {
  static readonly ROW = 'row';
  static readonly COLUMN = 'column';
  static readonly ROW_SPAN = 'rowSpan';
  static readonly COLUMN_SPAN = 'columnSpan';
  // static readonly FORMAT = 'format';
  // static readonly ALIGNMENT = 'alignment';
}

export class TableCellModel extends ContentModel implements TableCellData {
  static readonly KEYS = ContentModel.KEYS.concat(
    Object.keys(TableCellFieldKey).map((key) => TableCellFieldKey[key])
  );

  constructor(data?: TableCellData, keys?: string[]) {
    super(data, keys || TableCellModel.KEYS);
  }

  get row(): number {
    return this.get(TableCellFieldKey.ROW);
  }

  get column(): number {
    return this.get(TableCellFieldKey.COLUMN);
  }

  get rowSpan(): number {
    return this.get(TableCellFieldKey.ROW_SPAN);
  }

  get columnSpan(): number {
    return this.get(TableCellFieldKey.COLUMN_SPAN);
  }

  // get format(): string {
  //   return this.get(TableCellFieldKey.FORMAT);
  // }

  // set format(value: string) {
  //   this.set(TableCellFieldKey.FORMAT, value);
  // }

  // get alignment(): Alignment {
  //   return this.get(TableCellFieldKey.ALIGNMENT);
  // }

  // set alignment(value: Alignment) {
  //   this.set(TableCellFieldKey.ALIGNMENT, value);
  // }

  protected setupValues(values: TableCellData, exclusive: boolean): TableCellData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.TABLE_CELL;
    }
    return super.setupValues(values, exclusive) as TableCellData;
  }
}
